import _ from "lodash";
import h from "../core/createElement";
import ListGroupsModal from "../modals/list_groups";
import group_service from "../service/group_service";
import { btn_handler, dark_theme, get_object_from_storage, dark_theme_stored, patch_object_on_storage, switchable_element } from "../utils";
import Btn from "./btn";
import InputSideLabel from "./input_side_label";

export default function Header({ shared = {}, refresh_with_group }) {
    const
        full_spinner = shared.full_spinner,
        inner_shared = {},
        default_empty = [{ label: "-- nenhuma aplicação --", value: "" }],
        input_sel = switchable_element(<InputSideLabel title="Aplicação:" type="select" items={default_empty} />),
        dark_theme_btn = <Btn icon="assets/image/moon-stars.svg" color="dark-gray" onClick={() => toggle_dark_theme(true)} />,
        light_theme_btn = <Btn icon="assets/image/sun-dim.svg" onClick={() => toggle_dark_theme(false)} />,
        btn_switch = switchable_element(dark_theme_stored() ? light_theme_btn : dark_theme_btn);


    const { disable_btn, enable_btn } = btn_handler(inner_shared);

    const
        btn_list_click = () => {
            ListGroupsModal.show({ shared });
        },
        change_handler = (evt) => {
            const v = evt.target.value;
            if (shared.group_id == v) return;
            shared.group_id = v;
            refresh_with_group && refresh_with_group(v);
        },
        reload = async () => {
            disable_btn('reload_btn');
            refresh_with_group && await refresh_with_group(shared.group_id);
            setTimeout(() => enable_btn('reload_btn'), 500);
        },
        toggle_dark_theme = (bool) => {
            dark_theme(bool);
            btn_switch.switch(bool ? light_theme_btn : dark_theme_btn);
        };

    shared.header = {
        get_all_groups: async (selected) => {
            try {
                full_spinner.show();

                const { data } = await group_service.get();

                shared.group_array = data.data || [];

                const items = data.data.length ? _.chain(data.data).map(e => ({ label: e.name, value: e.id })).orderBy('value', 'asc').value() : default_empty;

                const default_v = selected ?? items[0]?.value;

                input_sel.switch(
                    <InputSideLabel
                        shared={inner_shared}
                        name="group_select"
                        defaultValue={default_v}
                        onChange={change_handler}
                        title="Aplicação:"
                        type="select"
                        items={items}
                    />
                );

                change_handler({ target: { value: _.find(shared.group_array, { id: default_v })?.id } });

                full_spinner.hide();
            } catch (e) {
                full_spinner.hide();
            };
        },
        select_group: (v) => {
            inner_shared.group_select.set_value(v);
            shared.group_id = v;
        }
    };

    return (
        <section class="header-container">
            <section class="content flex align-center">
                {input_sel.current()}
                <Btn icon="assets/image/list.svg" color="orange" onClick={btn_list_click} />
                <Btn icon="assets/image/arrows-clockwise.svg" shared={inner_shared} name="reload_btn" color="pink" onClick={reload} />
                {btn_switch.current()}
            </section>
        </section>
    );
};